/**
 * Copyright (C) 2021 Prosperia Salud, S.A. DE C.V. info@prosperia.health.
 * All rights reserved
 * DO NOT REDISTRIBUTE
 * The software MAY NOT be rewritten or refactored by any means. The code MAY
 * NOT be packaged and redistributed by any means without prior written
 * permission from the author.
 */
import React, { useContext } from 'react';
/// /// EXTERNAL /// ///
// mui //
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
// context //
import { ChannelParametersProvider } from '@prosperia/context.channel-parameters-context';
import { PocParametersProvider } from '@prosperia/context.poc-parameters-context';
import { ChannelParametersContext } from '@prosperia/context.channel-parameters-context';
import { PocParametersContext } from '@prosperia/context.poc-parameters-context';
import { InteractionProvider } from 'context/InteractionContext';
import { PatientProvider } from '@prosperia/context.patient-context';
// third party libraries //
import { useParams } from 'react-router-dom';
/// /// INTERNAL /// ///
// components //
import EnhancedSkeleton from 'components/atoms/common/EnhancedSkeleton';
import EnhancedSnackbar from 'components/atoms/common/EnhancedSnackbar';
// context //
import { InteractionContext } from 'context/InteractionContext';
// hook //
import useChannelParameters from 'hook/useChannelParameters';
import usePocParameters from 'hook/usePocParameters';
import RecaptchaReport from 'components/pages/RecaptchaReport';
import useTheme from 'hook/useTheme';
// utils //
import { INITIALIZE_PATIENT } from 'utils/constants';

const Theme = () => {
  const { POC } = useParams();
  const { lightTheme } = useTheme();
  const { isLoaderChannelParameters } = useContext(ChannelParametersContext);
  const { isLoaderPocParameters } = useContext(PocParametersContext);
  const { loadedReport, skipRecaptha } = useContext(InteractionContext);
  useChannelParameters();
  usePocParameters();

  let loader = loadedReport;
  if (loader) {
    loader = POC ? isLoaderPocParameters : isLoaderChannelParameters;
  }

  return (
    <EnhancedSkeleton loader={loader}>
      <ThemeProvider theme={lightTheme}>
        <EnhancedSnackbar />
        <CssBaseline />
        <RecaptchaReport skipRecaptha={skipRecaptha} />
      </ThemeProvider>
    </EnhancedSkeleton>
  );
};

const ReportProvider = () => (
  <ChannelParametersProvider>
    <PocParametersProvider>
      <PatientProvider initializePatient={INITIALIZE_PATIENT}>
        <InteractionProvider>
          <Theme />
        </InteractionProvider>
      </PatientProvider>
    </PocParametersProvider>
  </ChannelParametersProvider>
);

export default ReportProvider;
